/* eslint-disable */
import { makeStyles } from '@mui/styles'
import theme from '../../../theme'

export const useStyles = makeStyles(() => ({
	footer: {
		display: 'block',
		[theme.breakpoints.up('tablet')]: {
			display: 'flex',
			borderRight: '1px solid var(--line)'
		},
		[theme.breakpoints.up('laptop')]: {
			borderLeft: '1px solid var(--line)'
		},
	},
	footerWithoutBorder: {
		display: 'block',
		[theme.breakpoints.up('tablet')]: {
			display: 'flex'
		},
	},
	button: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		height: '64px',
		padding: '20px 29px 20px 20px',
		borderBottom: '1px solid var(--line)',
		fontSize: 18,
		fontWeight: 700,
		textDecoration: 'none !important',
		cursor: 'var(--cursor-pointer)'
	},
	contact: {
		maxWidth: '100%',
		[theme.breakpoints.up('laptop')]: {
			maxWidth: '100%',
		},
	},
	services: {
		display: 'flex',
		[theme.breakpoints.up('medium')]: {
			flex: 1,
			marginRight: 24,
			borderRight: '1px solid var(--line)',
		}
	},
	copyright: {
		flexDirection: 'row',
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.up('medium')]: {
			paddingRight: 24,
			borderTop: '1px solid var(--line)',
		}
	},
	wrapper: {
		display: 'flex',
		marginTop: 'auto',
	}
}))
